export default class GenerateRoundDocumentReportRequest {
  constructor({ roundId, ordererCode, customerCodes } = {}) {
    this.roundId = roundId || 0;
    this.ordererCode = ordererCode || null;
    this.customerCodes = customerCodes || [];
  }
}
